"use client";

import { useLanguage } from "@faire/retailer-visitor-shared/hooks/retailer/useLanguage";
import { useSettingRSCTopOfPageContent } from "@faire/retailer-visitor-shared/settings/useSettingRSCTopOfPageContent";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/useUserStore";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import React, { Suspense } from "react";

import { LazyLanguageSelector } from "../../LanguageSelector/LazyLanguageSelector";
import { HeaderLine } from "../styled";

export const LanguageSelectorSection = () => {
  const rscTopOfPageContent = useSettingRSCTopOfPageContent();
  const {
    showLanguageSelector,
    showSEOLanguageSelector,
    availableLanguageSelectorLocales,
  } = useLanguage();
  const { browserLevelLanguage, browserLevelLocaleKey } = useUserStore([
    "browserLevelLanguage",
    "browserLevelLocaleKey",
  ]);
  const fallback = rscTopOfPageContent ? (
    <div className="h-[60px] w-[90px]" />
  ) : null;
  return showLanguageSelector || showSEOLanguageSelector ? (
    <>
      <Suspense fallback={fallback}>
        <LazyLanguageSelector
          eventKey="logged-out-top"
          browserLanguage={browserLevelLanguage as Language}
          browserLocale={browserLevelLocaleKey}
          availableLocales={availableLanguageSelectorLocales}
          assignLocalizedUrl
        />
      </Suspense>
      <HeaderLine />
    </>
  ) : null;
};
